<template>
  <div class="header">
    <div class="main">
      <h1 class="inline" @click="goPath2('/home')">
        <img src="../../assets/logo.png" alt="" />
      </h1>
      <nav class="fright">
        <div class="">
          <div
            class="fleft nav"
            @click.stop="goPath(item, index)"
            @mouseover="mouseoverNav(item,index)"
            :class="active == index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
          >
            <h2>{{ item.name }}</h2>
            <transition name="bounce" v-if="subNav.length > 0 && !item.isProduct">
              <div
                class="subNav"
                :class="active == index && subNav.length > 0 ? 'subActive' : ''"
                @mouseleave="subNav = []"
              >
                <div
                  @click.stop="goPath1(item1)"
                  :class="index1 == active1 ? 'active' : ''"
                  v-for="(item1, index1) in subNav"
                  @mouseenter="active1 = index1"
                  @mouseleave="active1 = -1"
                  :key="index1"
                >
                  {{ item1.name }}
                  <span></span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </nav>
    </div>
    <el-dialog class='isProduct_wrap' :modal="false" custom-class="custom-dialog" :visible.sync="dialogVisible" width="1200px" append-to-body :show-close='false'>
      <el-container class="isProduct" :class="proTypeList.childrens.length>0?'shadow':'onlyBar'">
        <el-aside width="160px" style="background-color: #ededed" :class="proTypeList.childrens.length==0?'shadow':''">
          <ul>
            <li :class="bgIndex==index?'bg':''" @click="getType(it,index)" v-for="(it, index) in navList[1].children">
              {{ it.name }}<span v-if="it.childrens.length>0" class="el-icon-arrow-right"></span>
            </li>
          </ul>
        </el-aside>
        <!-- <el-main v-show='bgIndex>=0'> -->
        <el-main style='background-color:#fff' v-show='bgIndex>=0 && proTypeList.childrens.length>0'>
          <h3 class="typeName" @click='goPath3(proTypeList.id,-1)'>{{ proTypeList.name }}</h3>
          <hr />
          <div class="threeType" v-for="(ind, inde) in proTypeList.childrens">
            <h4 class="typeLastName" :class="lastIndex==inde?'active':''" @click='goPath3(ind.id,inde)'>{{ ind.name }}</h4>
            <div v-for="(i, inde) in ind.childrens">
              <p @click='goPath3(i.id,inde)'>{{ i.name }} <span class="el-icon-arrow-right"></span></p>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-dialog>
    <div class="rightMenu" @click="drawer = true">
      <span>
        <i></i>
      </span>
    </div>
    <el-drawer
      size="200px"
      :append-to-body="true"
      :visible.sync="drawer"
      :direction="direction" >
      <div class="menu">
        <div
          @click.stop="goPath(item)"
          @mouseover="mouseoverNav(index, item)"
          v-for="(item, index) in navList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getProductTree, applyDomainList, getDictList } from "../../api/index";
export default {
  data() {
    return {
      navList: [
        {
          name: "首页",
          path: "/home",
          isProduct: false,
        },
        {
          name: "产品中心",
          path: "/product/index",
          children: [],
          isProduct: true,
        },
        {
          name: "行业应用",
          path: "/apply",
          children: [],
          isProduct: false,
        },
        {
          name: "质量与可靠性",
          path: "/zlykkx/zlgl",
          children: [],
          isProduct: false,
        },
        {
          name: "服务支持",
          path: "/fwzc/onlineClass",
          children: [
            {
              name: "在线课堂",
              path: "/fwzc/onlineClass",
            },
            {
              name: "技术文章",
              path: "/fwzc/tecArticles",
            },
          ],
          isProduct: false,
        },
        {
          name: "关于士模",
          path: "/about",
          children: [
            {
              name: "公司介绍",
              path: "/about",
            },
            {
              name: "新闻资讯",
              path: "/news",
            },
            {
              name: "联系我们",
              path: "/introduce",
            },
            {
              name: "销售与代理商",
              path: "/fwzc/xsydls",
            },
          ],
          isProduct: false,
        },
        {
          name: "加入士模",
          path: "/joinUs",
          isProduct: false,
        },
      ],
      active: 0,
      subNav: [],
      active1: -1,
      drawer: false,
      direction: "rtl",
      proTypeList: {
        childrens:[]
      },
      isProduct: false,
      dialogVisible: false,
      bgIndex:0,
      showMenu:-1,
      lastIndex:-1,
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        this.drawer = false;
      },
      deep: true,
    },
  },
  methods: {
    handleMouseOut() {
      console.log("走了走了");
    },
    goPath2(path) {
      this.$router.push(path);
    },
    mouseoverNav(item,index) {
      this.subNav = item.children ? item.children : [];
      this.isProduct = item.isProduct;
      if (index == 1) {
        this.dialogVisible = true
        console.log(this.bgIndex);
        
        this.proTypeList = this.navList[1].children[this.bgIndex]
      }else{
        this.dialogVisible = false
      }
    },
    goPath(item, index) {
      if (index > -1) {
        this.active = index;
      }
      let path = this.$route.path;
      if (item.path == "/product/index") {
        this.$router.replace({ path: item.path, query: { id: 12 } });
        this.bgIndex = 0
        this.proTypeList = this.navList[1].children[0]
      }else{
        if (path != item.path) {
        this.$router.push(item.path);
        document.documentElement.scrollTop = 0;
      }
      }
      
    },
    goPath1(item) {
      if (item.path) {
        if (item.path == "/product/index") {
          this.$router.push({ path: item.path, query: { id: item.id } });
          document.documentElement.scrollTop = 0;
        } else if (item.path == "/apply") {
          this.$router.push({ path: item.path, query: { id: item.id } });
          document.documentElement.scrollTop = 0;
        } else {
          console.log(item.path);
          this.$router.push(item.path);
          document.documentElement.scrollTop = 0;
        }
      }
    },
    getType(it,index) {;
      this.proTypeList = it;
      // if (it.childrens.length==0) {
        this.$router.replace({ path: "/product/index", query: { id: it.id } });
      // }
      if (it.childrens.length==0) {
        this.dialogVisible = false
      }
      this.bgIndex = index
      this.lastIndex = -1
    },
    goPath3(id,index){
      let path = window.location.pathname
      if (path == '/product/index') {
        this.$router.replace({ path: "/product/index", query: { id: id } });
        console.log(index);
        this.lastIndex = index
      }else{
        this.$router.push({ path: "/product/index", query: { id: id } });
      }
      this.dialogVisible = false
      document.documentElement.scrollTop = 0;
    },
    closeDialog() {
      console.log(11111);
      this.dialogVisible = false;
    },

  },
  mounted() {
    getProductTree().then((res) => {
      // console.log(res.data);
      let data = res.data;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/product/index");
      }
      this.navList[1].children = res.data;
    });
    applyDomainList().then((res) => {
      let data = res.rows;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/apply");
      }
      this.navList[2].children = res.rows;
    });
    getDictList("cms_quality_reliability").then((res) => {
      let data = res.data;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/zlykkx/zlgl?id=" + element.dictValue);
        this.$set(element, "name", element.dictLabel);
      }
      this.navList[3].children = res.data;
    });
  },
};
</script>
<style scoped lang="scss">
/* 自定义遮罩层（模拟 modal 效果） */
.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* 内容区域样式 */
.dialog-content {
  background: white;
  padding: 20px;
  border-radius: 4px;
}
@media (min-width: 300px) {
  .main {
    width: 300px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 600px) {
  .main {
    width: 600px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 700px) {
  .main {
    width: 700px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 800px) {
  .main {
    width: 800px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 1000px) {
  .main {
    width: 1000px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 1100px) {
  .main {
    width: 1100px;
  }

  nav {
    display: block;
  }

  .rightMenu {
    display: none;
  }
}

/*>=1280的设备*/
@media (min-width: 1200px) {
  .main {
    width: 1200px;
  }

  nav {
    display: block;
  }

  .rightMenu {
    display: none;
  }
}

.header {
  position: fixed;
  width: 100%;
  background-color: rgba($color: #13458f, $alpha: 0.8);
  color: #fff;
  z-index: 2002;

  img {
    height: 60px;
    margin-top: 10px;
  }
}

.noActive {
  span {
    display: none !important;
  }
}

.active1 {
  span {
    display: block;
  }
}

.subNav {
  display: none;
  position: absolute;
  background: #fff;
  color: #1e1e1e;
  width: 120px;
  line-height: 80px;
  z-index: 999;
  padding: 0 10px 10px 10px;
  top: 78px;
  // height: 300px;
  left: 50%;
  margin-left: -60px;

  // transition:height 1s;
  div {
    line-height: 40px;
    margin-top: 10px;
  }
}

.bounce-enter-active,
.bounce-leave-active {
  transition: all 0;
}

.bounce-enter,
.bounce-leave-to {
  opacity: 0;
  // width: 0px;
}

.subNav {
  li {
    font-weight: bold;
    cursor: pointer;

    span {
      height: 3px;
      background-color: #fff;
    }
  }

  .active {
    span {
      display: block;
      width: 24px;
      height: 3px;
      background-color: #cf2b5d;
      margin: 0 auto;
    }
  }
}

.nav {
  position: relative;
  cursor: pointer;
  text-align: center;
  padding: 18px 14px;
  // width: 120px;
  h2 {
    font-size: 18px;
    line-height: 44px;
  }
}
.nav:hover {
  .subNav {
    display: block;
  }
  h2 {
    color: #cf2b5d;
  }
}
.nav.active {
  font-weight: bolder;
  // color: #cf2b5d;
  color: #cf2b5d;
  // background-color: #345689;
}

.rightMenu {
  width: 22px;
  height: 44px;
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;

  span {
    width: 22px;
  }

  i {
    display: block;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    top: 50%;
    width: 22px;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  i:before,
  i:after {
    width: 22px;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    content: "";
    display: block;
    position: absolute;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  i:after {
    top: 8px;
  }

  i:before {
    bottom: 8px;
  }
}

.menu {
  background-color: #fff;

  > div {
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
}
.fright {
  position: relative;
}


.isProduct {
  position: absolute;
  // right:8px;
  // // left: 0;
  // // top: 80px;
  // width: 700px;
  // background-color: #fff;
  color: #1e1e1e;
  right: 10px;
  // width: 632px;
  text-align: left;
  li {
    line-height: 40px;
    // font-weight: bold;
    font-size: 14px;
    padding: 4px 20px;
    cursor:pointer;
    span {
      display: inline-block;
      float: right;
      color: #231815;
      line-height: 40px;
    }
  }
  li:hover {
    background-color: #0b3576;
    color: #fff;
    span {
      color: #fff;
    }
  }
  li.bg{
    background-color: #0b3576;
    color: #fff;
    span {
      color: #fff;
    }
  }
  .typeName {
    color: #555555;
    // font-weight: bold;
    font-size: 14px;
    text-indent: 14px;
    cursor:pointer;
    
  }
    // .typeName:active{
    //   color:#000;
    // }
  .typeLastName {
    background-color: #ededed;
    height: 45px;
    line-height: 45px;
    text-indent: 10px;
    margin-bottom: 10px;
    color: #1e1e1e;
    font-size: 13px;
    cursor:pointer;
  }
  .typeLastName.active{
    color:#fff;
    background-color: #0b3576;

  }
  .threeType {
    // display:inline-block;
    float: left;
    width: 50%;
    padding: 4px;
    box-sizing: border-box;
    > div {
      p {
        line-height: 40px;
        color: #1e1e1e;
        border-bottom: 1px solid #e2e2e2;
        font-size: 14px;
        text-indent: 10px;
        cursor:pointer;
        span {
          display: inline-block;
          float: right;
          margin-right: 6px;
          line-height: 40px;
        }
      }
    }
  }
}
.shadow{
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width:632px;
}
.onlyBar{
  right:482px
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue